import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  padding: 0 10px;
  min-width: 104px;
  height: 44px;
  background-color: var(--fd-colors-component-data-input-background-base);
  box-shadow: 0 1px 3px rgb(17 43 68 / 12%);
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: var(--fd-colors-component-data-input-background-hover);
  }

  &:disabled {
    background-color: var(--fd-colors-component-data-input-background-base);
    cursor: initial;
    opacity: 0.5;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-grow: 1;
  pointer-events: none;
`;
